import { ILocation } from '../../../libraries/location';
import { createAction } from '../actions';
import { AppDispatch } from '../store';
import { ActionTypes } from './actionTypes';

export const saveLocationsInfo = (locationsInfo: ILocation[]) => (dispatch: AppDispatch) => {
  dispatch(createAction(ActionTypes.SAVE_LOCATIONS, locationsInfo));
};
